__turbopack_context__.v({
  "actionButton": "Safari-module__FjG6-G__actionButton",
  "actionButtonGhost": "Safari-module__FjG6-G__actionButtonGhost",
  "actions": "Safari-module__FjG6-G__actions",
  "author": "Safari-module__FjG6-G__author",
  "body": "Safari-module__FjG6-G__body",
  "controls": "Safari-module__FjG6-G__controls",
  "hint": "Safari-module__FjG6-G__hint",
  "list": "Safari-module__FjG6-G__list",
  "message": "Safari-module__FjG6-G__message",
  "messageHeader": "Safari-module__FjG6-G__messageHeader",
  "modeBadge": "Safari-module__FjG6-G__modeBadge",
  "modeLegend": "Safari-module__FjG6-G__modeLegend",
  "modeOption": "Safari-module__FjG6-G__modeOption",
  "modePicker": "Safari-module__FjG6-G__modePicker",
  "root": "Safari-module__FjG6-G__root",
  "scroller": "Safari-module__FjG6-G__scroller",
  "time": "Safari-module__FjG6-G__time",
});
